import React from "react";
import './assets/css/Covihack_Tracks.css';
const Hack_o_relay_rules=()=>{
    return(
        <div className="rules">
            <h1 className="heading">--- Rules ---</h1>
            <ul>
                <li>5 problem statements for each track will be released on 25th May, 2022. Team has to choose a problem statement and make a product.</li>
                <li>Students can either take part individually or in a team of upto 4 members.</li>
                <li>Team can take part in only 1 track</li>
                <li>The duration of the hackathon will be 3 hours. (2nd half of college)</li>
                <li>The teams will be evaluated on the basis of the time of their last git commit.</li>
                <li>Teams can start collecting the assets of their project before the actual competition, they just need to start coding (for development) or making the product in the 3 hours time frame.</li>
                <li>Plagiarism of any kind will result in disqualification.</li>
                <li>All information presented in the video must be cited, giving credit to the original source.</li>
                <li>No copyrighted materials (music, images, video clips, etc.) may be used for this contest.</li>
                <li>Revealing face is not compulsory ( You can either create an animated video or any normal video showing your face) in the content creation track.</li>
                <li>Extra point will be alloted to those, who use original gifs, illustration, etc. inanimated video  in the content creation track.</li>
                <li>Using Caption regarding the video is a must  in the content creation track.</li>
                <li>Any kind of abusive language should not be entertained.</li>
            </ul>
        </div>
    );
}
export default Hack_o_relay_rules;